import { useCallback } from "react";
import { useBlocker } from "react-router-dom";
import { shouldBlockBrowserBackAfterReload } from "../common/browserHistoryNavigation";

/**
 * Disables browser back navigation when the current page was loaded via refresh (F5).
 */
export function useDisableBrowserBackOnRefresh(): void {
  const shouldBlock = useCallback(
    ({ historyAction }: { historyAction: "POP" | "PUSH" | "REPLACE" }) =>
      shouldBlockBrowserBackAfterReload() && historyAction === "POP",
    []
  );

  useBlocker(shouldBlock);
}
